import { SessionStorageFacade } from "./session-storage.facade";
import { LocalStorageFacade } from "./local-storage.facade";
/**
 * 租户信息
 */
export class TenantInfoFacade extends SessionStorageFacade {

    static key = 'thyTenantInfo';

    static set(value) {
        return super.set(this.key, value);
    }

    /**
     * @return {{
     *    "id": 1700090446,
     *    "viewType": null,
     *    "tenantCode": "portal-saas_2110295011",
     *    "templateCode": "global-portal-premium",
     *    "domain": null,
     *    "status": 6,
     *    "makeDomain": "shen1029_098a34cf6d8140c39ef0111b372be6b5.p.make.test-dcloud.portal1.portal.thefastmake.com",
     *    "productDomain": "shen1029_098a34cf6d8140c39ef0111b372be6b5.p.oper.test-dcloud.portal1.portal.fastoper.com",
     *    "pcPublishTime": 1673398849000,
     *    "mobileDomain": null,
     *    "mobileStatus": 8,
     *    "mobileMakeDomain": "shen1029_098a34cf6d8140c39ef0111b372be6b5.m.make.test-dcloud.portal1.portal.thefastmake.com",
     *    "mobileProductDomain": "shen1029_098a34cf6d8140c39ef0111b372be6b5.m.oper.test-dcloud.portal1.portal.fastoper.com",
     *    "mobilePublishTime": 1673398849000,
     *    "unittype": "portal-saas",
     *    "language": "zh_CN",
     *    "foreign": false,
     *    "productMode": false,
     *    "formal": null,
     *    "instance": "SHEN1029_098a34cf6d8140c39ef0111b372be6b5",
     *    "cdnFlag": "2",
     *    "ningkerDomain": "DOMESTIC_TRADE",
     *    "ningkerCustomerDomain": null,
     *    "fieldTag": "pdr",
     *    "fieldValue": "test-designCloud-pc",
     *    "pool": "portal1",
     *    "rem": "portal-saas",
     *    "productType": "1",
     *    "memberId": "1",
     *    "custId": "1",
     *    "deployPlan": null
     *  }}
     */
    static get() {
        return super.get(this.key);
    }

}
export class BmTenantInfoFacade extends LocalStorageFacade {

    static key = 'bmTenantInfo';

    static set(value) {
        return super.set(this.key, value);
    }

    /**
     * @return {{
     *    "id": 1700090446,
     *    "viewType": null,
     *    "tenantCode": "portal-saas_2110295011",
     *    "templateCode": "global-portal-premium",
     *    "domain": null,
     *    "status": 6,
     *    "makeDomain": "shen1029_098a34cf6d8140c39ef0111b372be6b5.p.make.test-dcloud.portal1.portal.thefastmake.com",
     *    "productDomain": "shen1029_098a34cf6d8140c39ef0111b372be6b5.p.oper.test-dcloud.portal1.portal.fastoper.com",
     *    "pcPublishTime": 1673398849000,
     *    "mobileDomain": null,
     *    "mobileStatus": 8,
     *    "mobileMakeDomain": "shen1029_098a34cf6d8140c39ef0111b372be6b5.m.make.test-dcloud.portal1.portal.thefastmake.com",
     *    "mobileProductDomain": "shen1029_098a34cf6d8140c39ef0111b372be6b5.m.oper.test-dcloud.portal1.portal.fastoper.com",
     *    "mobilePublishTime": 1673398849000,
     *    "unittype": "portal-saas",
     *    "language": "zh_CN",
     *    "foreign": false,
     *    "productMode": false,
     *    "formal": null,
     *    "instance": "SHEN1029_098a34cf6d8140c39ef0111b372be6b5",
     *    "cdnFlag": "2",
     *    "ningkerDomain": "DOMESTIC_TRADE",
     *    "ningkerCustomerDomain": null,
     *    "fieldTag": "pdr",
     *    "fieldValue": "test-designCloud-pc",
     *    "pool": "portal1",
     *    "rem": "portal-saas",
     *    "productType": "1",
     *    "memberId": "1",
     *    "custId": "1",
     *    "deployPlan": null
     *  }}
     */
    static get() {
        return super.get(this.key);
    }

}